import CircleFilled from './src/circle-filled';
export default CircleFilled;